import { LOCALE } from '@constants/locale';
import { BILLING_TIME_MAP, BILLING_TYPE_MAP } from '@constants/billing';

export const getPricingPlans = (locale, locationsNumber) => {
    const isSingleLocation = locationsNumber === 1;
    switch (locale) {
        case LOCALE.BRAZIL:
            return {
                [BILLING_TIME_MAP.MONTHLY]: {
                    users: 99,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 249 : 199,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 499 : 349,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: 'R$',
                    currency: 'BRL',
                },
                [BILLING_TIME_MAP.ANNUAL]: {
                    users: 990,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 2490 : 1990,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 4990 : 3490,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: 'R$',
                    currency: 'BRL',
                },
            };
        case LOCALE.PORTUGAL:
        case LOCALE.SPAIN:
        case LOCALE.POLAND:
        case LOCALE.GERMANY:
            return {
                [BILLING_TIME_MAP.MONTHLY]: {
                    users: 18,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 45 : 36,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 95 : 65,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: '€',
                    currency: 'EUR',
                },
                [BILLING_TIME_MAP.ANNUAL]: {
                    users: 180,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 450 : 360,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 950 : 650,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: '€',
                    currency: 'EUR',
                },
            };
        case LOCALE.UNITED_KINGDOM:
            return {
                [BILLING_TIME_MAP.MONTHLY]: {
                    users: 15,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 39 : 32,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 79 : 55,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: '£',
                    currency: 'GBP',
                },
                [BILLING_TIME_MAP.ANNUAL]: {
                    users: 150,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 390 : 320,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 790 : 550,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: '£',
                    currency: 'GBP',
                },
            };
        default:
            return {
                [BILLING_TIME_MAP.MONTHLY]: {
                    users: 19,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 49 : 39,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 99 : 69,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: '$',
                    currency: 'USD',
                },
                [BILLING_TIME_MAP.ANNUAL]: {
                    users: 190,
                    price: {
                        [BILLING_TYPE_MAP.STARTER]: isSingleLocation ? 490 : 390,
                        [BILLING_TYPE_MAP.PROFESSIONAL]: isSingleLocation ? 990 : 690,
                        [BILLING_TYPE_MAP.ENTERPRISE]: 0,
                    },
                    symbol: '$',
                    currency: 'USD',
                },
            };
    }
};
